export const enum SubmitResult {
  ACCEPTED = 'ACCEPTED',
  ERROR = 'ERROR',
  NONE = 'NONE',
}

export const enum SubmitErrorType {
  NONE = 'NONE',
  CLAIM_REJECTED = 'CLAIM_REJECTED',
  CLAIM_ACKNOWLEDGED = 'CLAIM_ACKNOWLEDGED',
  CLAIM_ACKNOWLEDGED_NULLIFIED = 'CLAIM_ACKNOWLEDGED_NULLIFIED',
  SUBMIT_CLAIM_NO_RETRY_ERROR = 'SUBMIT_CLAIM_NO_RETRY_ERROR',
  LIMIT_REACHED = 'LIMIT_REACHED',
  INSURER_ERROR = 'INSURER_ERROR',
  INSUFFICIENT_COVERAGE = 'INSUFFICIENT_COVERAGE',
  REQUEST_QUOTE_ERROR = 'REQUEST_QUOTE_ERROR',
  REQUEST_QUOTE_RESTRICTED = 'REQUEST_QUOTE_RESTRICTED',
  SUBMIT_QUOTE_ERROR = 'SUBMIT_QUOTE_ERROR',
  SUBMIT_QUOTE_NO_RETRY_ERROR = 'SUBMIT_QUOTE_NO_RETRY_ERROR',
  REFUSE_QUOTE_ERROR = 'REFUSE_QUOTE_ERROR',
  GENERIC_ERROR = 'GENERIC_ERROR',
}

export type SubmitError = {
  type: SubmitErrorType
  claimId?: string
  details?: string
}

export const enum SubmitType {
  DEFAULT = 'DEFAULT',
  ACCEPT_QUOTE = 'ACCEPT_QUOTE',
  REQUEST_QUOTE = 'REQUEST_QUOTE',
  REFUSE_QUOTE = 'REFUSE_QUOTE',
  FIND_INSURANCE_MEMBER = 'FIND_INSURANCE_MEMBER',
}
